<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div class="flex justify-between w-full items-center">
        <div class="flex flex-col">

          <div class="flex items-center gap-1">
            <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
              <button mat-icon-button color="primary">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
              </button>
            </div>

            <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
              <div class="p-4">
                <p>
                  Se aplican configuraciones específicas
                  para los pedidos, cotizaciones, entrega
                  y factura.
                </p>
              </div>
            </mat-menu>
            <h2 class="text-xl font-semibold leading-8 tracking-tight">
              CLases de Línea
            </h2>
          </div>

          <div class="text-sm text-secondary font-medium tracking-tight">
            Visualiza las <b>clases de línea</b> disponibles en AVE.
          </div>
        </div>
        <app-status-filters [selectedStatuses]="selectedStatuses"
          [showStatus]="[StatusEnum.ACTIVE, StatusEnum.INACTIVE]" (selectionFilterApply)="applyStatusFilter()">
        </app-status-filters>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Tipos de Línea</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button mat-icon-button color="primary" (click)="openModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">

        <app-smart-grid [data]="dataSource.data" [columnDefs]="columnDefs" [config]="gridConfig" [loading]="false"
          [totalRecords]="totalItems" (gridReady)="onGridReady($event)" (pageChanged)="changePage($event)"
          (sortChanged)="changeSort($event)">
        </app-smart-grid>

      </div>
    </div>
  </div>

  <app-filter
    (onFilterEvent)="findAllWithCount()" (onCleanEvent)="onClearFilter()" (onPanelOpened)="onFilterPanelOpened()">

    <app-configuration-filters [form]="formFilter" [company]="true" [loadData]="loadFiltersData"></app-configuration-filters>

    <app-documents-filters [form]="formFilter" [documentTypeLine]="true" [loadData]="loadFiltersData"></app-documents-filters>
  </app-filter>
</mat-sidenav-container>